import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Singleton service that broadcasts when a CDK drag operation starts.
 * Consumers such as hover overlays (e.g. MatMenuOnHoverDirective) can subscribe
 * to close themselves before the drag preview takes over the pointer.
 */
@Injectable({ providedIn: 'root' })
export class DragStateService {
  private readonly dragStartedSubject = new Subject<void>();

  public readonly dragStarted$: Observable<void> = this.dragStartedSubject.asObservable();

  public notifyDragStarted(): void {
    this.dragStartedSubject.next();
  }
}
